'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import http from 'hub-http/clients/apiClient';
const HubHttpMethodMap = {
  GET: 'get',
  POST: 'post',
  PUT: 'put',
  DELETE: 'delete'
};
const defaults = {
  timeout: 30000,
  // our endpoints aren't always fast :(
  maxRetries: 2,

  retry(xhr) {
    return xhr.status >= 500 || xhr.readyState === 0 && xhr.statusText !== 'abort';
  }

};
export default {
  apiRequest(url, _ref = {}) {
    let {
      type
    } = _ref,
        customOptions = _objectWithoutPropertiesLoose(_ref, ["type"]);

    const options = Object.assign({}, defaults, {}, customOptions);

    if (type) {
      const hubHttpMethodType = HubHttpMethodMap[type];
      return http[hubHttpMethodType](url, options);
    } else {
      // HapiJS.apiRequest used to default to 'GET', so as a result,
      // many GET calls in /data/*.js don't include a 'type' param
      return http.get(url, options);
    }
  }

};